// Configuración de URLs
export const URL_CONFIG = {
  // URLs base por servicio/plataforma
  SERVICES: {
    BLOG: {
      es: "https://grow.possumus.tech/es",
      en: "https://grow.possumus.tech/en"
    },
  },
  
  // Rutas de recursos organizadas por servicio
  RESOURCES: {
    BLOG: {
      ARTICLES: {
        MICROSOFT_DESIGNATIONS: {
          es: "/news/microsoft-designations-and-specializations-es",
          en: "/news/microsoft-designations-and-specializations"
        }
      },
    }
  }
};

export const buildUrl = (service, language, resourcePath = '') => {
  const serviceConfig = URL_CONFIG.SERVICES[service];
  if (!serviceConfig) {
    console.warn(`Service "${service}" not found in URL_CONFIG.SERVICES`);
    return '#';
  }
  
  const baseUrl = serviceConfig[language] || serviceConfig.en;
  return `${baseUrl}${resourcePath}`;
};

export const getResourceUrl = (service, resourceType, resourceKey, language) => {
  const resources = URL_CONFIG.RESOURCES[service];
  if (!resources) {
    return buildUrl(service, language);
  }
  
  const resourceTypeData = resources[resourceType];
  if (!resourceTypeData) {
    return buildUrl(service, language);
  }
  
  const resourcePaths = resourceTypeData[resourceKey];
  if (!resourcePaths) {
    return buildUrl(service, language);
  }
  
  const resourcePath = resourcePaths[language] || resourcePaths.en;
  return buildUrl(service, language, resourcePath);
};